import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { SelectPicker } from "rsuite";
import api from "../../Utils/api";

export default function AddNewLocation() {
  const [name, setName] = useState("");
  const [area, setArea] = useState(""); // New area field
  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState("");
  const [city, setCity] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [country, setCountry] = useState("Ireland");

  const navigate = useNavigate();

  const countryNames = [
    "Afghanistan",
    "Albania",
    "Algeria",
    "Andorra",
    "Anguilla",
    "Antigua and Barbuda",
    "Argentina",
    "Armenia",
    "Ascension",
    "Australia",
    "Austria",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bermuda Is",
    "Bolivia",
    "Botswana",
    "Brazil",
    "Brunei",
    "Bulgaria",
    "Burkina Faso",
    "Burma",
    "Burundi",
    "Cameroon",
    "Canada",
    "Cayman Is",
    "Central African Republic",
    "Chad",
    "Chile",
    "China",
    "Colombia",
    "Congo",
    "Cook Is",
    "Costa Rica",
    "Cuba",
    "Cyprus",
    "Czech Republic",
    "Denmark",
    "Djibouti",
    "Dominica Rep",
    "Ecuador",
    "Egypt",
    "EI Salvador",
    "Estonia",
    "Ethiopia",
    "Fiji",
    "Finland",
    "France",
    "French Guiana",
    "French Polynesia",
    "Gabon",
    "Gambia",
    "Georgia",
    "Germany",
    "Ghana",
    "Gibraltar",
    "Greece",
    "Grenada",
    "Guam",
    "Guatemala",
    "Guinea",
    "Guyana",
    "Haiti",
    "Honduras",
    "Hongkong",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Iran",
    "Iraq",
    "Ireland",
    "Israel",
    "Italy",
    "Ivory Coast",
    "Jamaica",
    "Japan",
    "Jordan",
    "Kampuchea (Cambodia)",
    "Kazakstan",
    "Kenya",
    "Korea",
    "Kuwait",
    "Kyrgyzstan",
    "Laos",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Macao",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Mariana Is",
    "Martinique",
    "Mauritius",
    "Mexico",
    "Moldova",
    "Monaco",
    "Mongolia",
    "Montserrat Is",
    "Morocco",
    "Mozambique",
    "Namibia",
    "Nauru",
    "Nepal",
    "Netheriands Antilles",
    "Netherlands",
    "New Zealand",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "North Korea",
    "Norway",
    "Oman",
    "Pakistan",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines",
    "Poland",
    "Portugal",
    "Puerto Rico",
    "Qatar",
    "Reunion",
    "Romania",
    "Russia",
    "Saint Lucia",
    "Saint Vincent",
    "Samoa Eastern",
    "Samoa Western",
    "San Marino",
    "Sao Tome and Principe",
    "Saudi Arabia",
    "Senegal",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Slovakia",
    "Slovenia",
    "Solomon Is",
    "Somalia",
    "South Africa",
    "Spain",
    "Sri Lanka",
    "Sudan",
    "Suriname",
    "Swaziland",
    "Sweden",
    "Switzerland",
    "Syria",
    "Taiwan",
    "Tajikistan",
    "Tanzania",
    "Thailand",
    "Togo",
    "Tonga",
    "Trinidad and Tobago",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Uganda",
    "Ukraine",
    "United Arab Emirates",
    "United Kingdom",
    "United States of America",
    "Uruguay",
    "Uzbekistan",
    "Venezuela",
    "Vietnam",
    "Yemen",
    "Yugoslavia",
    "Zimbabwe",
    "Zaire",
    "Zambia",
    "Montenegro ",
  ].map((item) => ({ label: item, value: item }));

  const handleCountryChange = (value) => {
    setCountry(value);
  };

  const submitLocation = async () => {
    // Validate inputs
    if (!name || !area || !address1 || !country) {
      toast.warn("Please fill in all required fields correctly!");
      return;
    }
    const res = await api.post("/location", {
      name,
      area, // Include area in request
      address1,
      address2,
      city,
      zipCode,
      country,
    });

    if (res.data.success) {
      toast.success(res.data.message);
      navigate("/locations");
    } else if (res.data.status === "warn") {
      toast.warn(res.data.message);
    } else {
      toast.error("Failed to add location");
    }
  };

  return (
    <div className="bg-white rounded-xl shadow-md p-6 max-w-2xl m-24 mx-auto border border-[#d8d7dc]">
      <h2 className="text-[24px] font-semibold text-gray-900 mb-2">
        Add new location
      </h2>
      <p className="text-sm text-gray-600 mb-6">
        A location is a place where business operations take place.
      </p>
      <form
        className="space-y-4"
        onSubmit={(e) => {
          e.preventDefault();
          submitLocation();
        }}
      >
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Location Name <span className="text-red-500">*</span>
          </label>
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-full border text-gray-800 rounded px-3 py-2 mt-1 focus:outline-none focus:ring-2 focus:ring-gray-300"
            placeholder="The Corner Cafe"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">
            Area <span className="text-red-500">*</span>
          </label>
          <input
            value={area}
            onChange={(e) => setArea(e.target.value)}
            className="w-full border rounded px-3 py-2 mt-1 focus:outline-none focus:ring-2 focus:ring-gray-300"
            placeholder="Downtown, Business District, etc."
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">
            Country <span className="text-red-500">*</span>
          </label>
          {/* <select
            value={country}
            onChange={(e) => setCountry(e.target.value)}
            className="w-full border rounded px-3 py-2 text-gray-700 mt-1 focus:outline-none focus:ring-2 focus:ring-gray-300"
            required
          >
            <option value="Ireland">Ireland</option>
          </select> */}
          <SelectPicker
            data={countryNames}
            value={country || ""}
            onChange={handleCountryChange}
            appearance="default"
            placeholder=""
            className="w-[622px]"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Address line 1 <span className="text-red-500">*</span>
          </label>
          <input
            value={address1}
            onChange={(e) => setAddress1(e.target.value)}
            className="w-full border rounded px-3 py-2 mt-1 focus:outline-none focus:ring-2 focus:ring-gray-300"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Address line 2
          </label>
          <input
            value={address2}
            onChange={(e) => setAddress2(e.target.value)}
            className="w-full border rounded px-3 py-2 mt-1 focus:outline-none focus:ring-2 focus:ring-gray-300"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Suburb / Town / City <span className="text-red-500">*</span>
          </label>
          <input
            value={city}
            onChange={(e) => setCity(e.target.value)}
            className="w-full border rounded px-3 py-2 mt-1 focus:outline-none focus:ring-2 focus:ring-gray-300"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Postal code / ZIP code <span className="text-red-500">*</span>
          </label>
          <input
            value={zipCode}
            onChange={(e) => setZipCode(e.target.value)}
            className="w-full border rounded px-3 py-2 mt-1 focus:outline-none focus:ring-2 focus:ring-gray-300"
          />
        </div>
        <div className="flex justify-end gap-4 mt-6">
          <button
            type="button"
            onClick={() => navigate("/locations")}
            className="px-4 py-2 rounded text-white bg-gray-100 hover:bg-gray-600"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="px-4 py-2 rounded text-white bg-gray-500 hover:bg-[#4c389d]"
          >
            Add Location
          </button>
        </div>
      </form>
    </div>
  );
}
